'use strict'
import 'babel-polyfill'
import ServiceExec from '@/common/utils/ServiceExec'
import {forEach} from "lodash";
import store from '@/store'
import Util from "@/common/utils/Util"

class AccountSvc extends ServiceExec {

  /**
   * 약관 리스트 조회
   *
   * @param params
   * @returns {Q.Promise<any> | Promise<any> | * | PromiseLike<any>}
   */
  getTermsList(params = {}) {
    const formData = new FormData()
    forEach(params, function (value, key) {
      formData.append(key, value)
    })
    return this.post(`/app/account/getTermsList`, formData)
      .then(res => res.data)
  }

  /**
   * 유저 정보 갱신
   *
   * @param params
   * @returns {Promise<any> | Q.Promise<any> | * | PromiseLike<any>}
   */
  refreshUserData(params = {}) {
    const formData = new FormData()
    forEach(params, function (value, key) {
      formData.append(key, value)
    })
    return this.post(`/api/app/account/refresh`, formData)
      .then(res => {
        if (res.data.code === 1) {
          let authToken = res.headers.user_login_token
          let userData = res.data.entity

          if (!Util.isEmpty(authToken)) {
            store.commit('account/setUserData', {userData: JSON.stringify(userData)})
          }
        }
        return res.data;
      })
  }

  /**
   * 로그인
   *
   * @param params
   * @returns {Promise<any> | Q.Promise<any> | * | PromiseLike<any>}
   */
  login(params = {}) {
    const formData = new FormData()
    forEach(params, function (value, key) {
      formData.append(key, value)
    })
    return this.post(`/api/app/account/login`, formData)
      .then(res => {
        if (res.data.code === 1) {
          let authToken = res.headers.user_login_token
          let userData = res.data.entity

          if (!Util.isEmpty(authToken)) {
            localStorage.isAutoLogin = params.isAutoLogin
            store.commit('account/storeLogin', {accessToken: authToken, userData: JSON.stringify(userData)})
          }
        }
        return res.data;
      })
  }

  /**
   * 로그아웃
   *
   * @param params
   * @returns {Promise<any> | Q.Promise<any> | * | PromiseLike<any>}
   */
  logout (params = {}) {
    return this.post(`/api/app/account/logout`, params)
      .then(res => {
        this.store.commit('account/storeLogout')
        return res.data
      })
  }

  /**
   * 아이디 찾기
   *
   * @param params
   * @returns {Promise<any> | Q.Promise<any> | * | PromiseLike<any>}
   */
  findUserID(params = {}) {
    const formData = new FormData()
    forEach(params, function (value, key) {
      formData.append(key, value)
    })
    return this.post(`/api/app/account/findUserID`, formData)
      .then(res => res.data)
  }

  /**
   * 비밀번호 찾기
   *
   * @param params
   * @returns {Promise<any> | Q.Promise<any> | * | PromiseLike<any>}
   */
  findUserPWD(params = {}) {
    const formData = new FormData()
    forEach(params, function (value, key) {
      formData.append(key, value)
    })
    return this.post(`/api/app/account/findUserPWD`, formData)
      .then(res => res.data)
  }

  /**
   * 회원 가입
   *
   * @param params
   * @returns {Promise<any> | Q.Promise<any> | * | PromiseLike<any>}
   */
  join(params = {}) {
    const formData = new FormData()
    forEach(params, function (value, key) {
      formData.append(key, value)
    })
    return this.post(`/api/app/account/join`, formData)
      .then(res => {
        if (res.data.code === 1) {
          let authToken = res.headers.user_login_token
          let userData = res.data.entity

          if (!Util.isEmpty(authToken)) {
            store.commit('account/storeLogin', {accessToken: authToken, userData: JSON.stringify(userData)})
          }
        }
        return res.data;
      })
  }

  /**
   * 담당자 정보 변경
   *
   * @param params
   * @returns {Promise<any> | Q.Promise<any> | * | PromiseLike<any>}
   */
  modifyContact(params = {}) {
    return this.queryPost(`/api/app/account/modifyContact`, params)
      .then(res => res.data)
  }

  /**
   * 비밀번호 변경
   *
   * @param params
   * @returns {Promise<any> | Q.Promise<any> | * | PromiseLike<any>}
   */
  modifyUserPWD(params = {}) {
    const formData = new FormData()
    forEach(params, function (value, key) {
      formData.append(key, value)
    })
    return this.post(`/api/app/account/modifyUserPWD`, formData)
      .then(res => res.data)
  }

  /**
   * 주소 변경
   *
   * @param params
   * @returns {Promise<any> | Q.Promise<any> | * | PromiseLike<any>}
   */
  modifyCompanyAddress(params = {}) {
    const formData = new FormData()
    forEach(params, function (value, key) {
      formData.append(key, value)
    })
    return this.post(`/api/app/account/modifyAddress`, formData)
      .then(res => res.data)
  }


  /**
   * 회원 탈퇴
   *
   * @param params
   * @returns {Promise<any> | Q.Promise<any> | * | PromiseLike<any>}
   */
  withdraw(params = {}) {
    const formData = new FormData()
    forEach(params, function (value, key) {
      formData.append(key, value)
    })
    return this.post(`/api/app/account/withdraw`, formData)
      .then(res => {
        this.store.commit('account/storeLogout')
        return res.data
      })
  }

  /**
   * 알림 변경
   *
   * @param params
   * @returns {Q.Promise<any> | Promise<any> | * | PromiseLike<any>}
   */
  modifyUserAlrim(params = {}) {
    const formData = new FormData()
    forEach(params, function (value, key) {
      formData.append(key, value)
    })
    return this.post(`/api/app/account/setAlrim`, formData)
      .then(res => res.data)
  }

  modifyCompany(params = {}) {
    return this.queryPost(`/api/app/account/modifyCompany`, params)
      .then(res => {
        return res.data
      })
  }

  registInquire(params = {}) {
    return this.queryPost(`/api/app/account/registInquire`, params)
      .then(res => res.data)
  }
}

export default new AccountSvc()
